export enum FileTypes {
  PDF = 'pdf',
  PNG = 'png',
  JPG = 'jpg',
  JPEG = 'jpeg',
  HEIC = 'heic',
  CSV = 'csv',
  GIF = 'gif',
  JSON = 'json',
  WEBP = 'webp',
  SVG = 'svg',
}
